import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'invoiceType',
    standalone: false
})
export class InvoiceTypePipe implements PipeTransform {
  transform(value: string): string {
    const normalizedValue = value.trim().toLowerCase();

    if (normalizedValue.startsWith('factura')) {
      return 'Factura';
    } else if (normalizedValue.startsWith('recibo')) {
      return 'Recibo';
    } else {
      return 'Crédito';
    }
  }
}
